import React from 'react';
import type { IconProps } from './types';

// Pushpin glyph. `filled` toggles between the solid (pinned) and outline
// (unpinned) states; `strokeWidth` is tunable for the visual weights in use.
const PinIcon: React.FC<IconProps & { filled?: boolean; strokeWidth?: number }> = ({
  size = 13,
  color = 'currentColor',
  filled = true,
  strokeWidth = 1.2,
  ...props
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      d="M14.5 3l6.5 6.5-2 2-.9-.3-3.6 3.6.3 2.7-1.8 1.8-4-4L4 20l-1-1 4.7-5-4-4L5.5 8.2l2.7.3 3.6-3.6-.3-.9 2-2Z"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export default PinIcon;
